import { tWithKeyAttr as t } from "../../../i18nHelper";
import styles from "./programDatesPopup.module.css";
import { TAppointment } from "../../../services/types/user.types";
import reportsIcon from "../../../images/reports_icon.svg";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import CancleAppointmentPopup from "../cancleAppointmentPopup/cancleAppointmentPopup";
import Modal from "../modal/Modal";
import { ITreatmentPlan } from "../../../types/types";
import { isDateAfterToday } from "../../../utils/utils";
import useMediaQuery from "../../../hooks/useMediaQuery";
import { mobileWidth, weekDayTitleKeys } from "../../../utils/constants";
import { useNavigate } from "react-router-dom";
import Loader from "../../loader/loader";
import AlternativeAppointmentPopup from "../alternativeAppointmentPopup/alternativeAppointmentPopup";
import GeneralErrorPopup from "../errorPopup/errorPopup";
import { useActions } from "../../../services/hooks/useActions";

interface ProgramDatesPopupProps {
  treatmentPlan: ITreatmentPlan;
  programDates: TAppointment[] | null;
  setProgramDates: Dispatch<SetStateAction<TAppointment[] | null>>;

  onClose: () => void;
  onFullClose: () => void;
  isLoading?: boolean;
}

function ProgramDatesPopup({
  treatmentPlan,
  programDates: programDatesList,
  setProgramDates: setProgramDatesList,
  //programDatesList,
  //setProgramDate
  //onClose,
  onFullClose,
  isLoading,
}: ProgramDatesPopupProps) {
  const navigate = useNavigate();
  const mobile = useMediaQuery(mobileWidth);

  const sortedProgramDatesList = programDatesList
    ? [...programDatesList]
      .filter((item) => item.statusId && item.id > 0)
      .sort(
        (a, b) =>
          new Date(a.appointmentDate).getTime() -
          new Date(b.appointmentDate).getTime()
      )
    : [];
  const [programDates, setProgramDates] = useState<TAppointment[] | null>(
    sortedProgramDatesList
  );
  const [cancle, setCancle] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [currentDate, setCurrentDate] = useState("");
  const [alternativeDate, setAlternativeDate] = useState("");

  const { setSelectedServiceId } = useActions();
  useEffect(() => {
    setSelectedServiceId(treatmentPlan.appointmentsProgram.companyServicesId ?? null);
  }, [treatmentPlan.appointmentsProgram.companyServicesId, setSelectedServiceId]);
  const handleProgramDatesChanged = (
    programDatesChanged: TAppointment[] | null
  ) => {
    const sorted = programDatesChanged
      ? [...programDatesChanged].sort(
        (a, b) =>
          new Date(a.appointmentDate).getTime() -
          new Date(b.appointmentDate).getTime()
      )
      : null;
   // setProgramDates(sorted);                                                                                                                                          
   setProgramDatesList(sorted);
  };

  const handleSuccessModal = (change: boolean, date: string) => {
    setOpenSuccessModal(change);
    setAlternativeDate(date);
  };

  const getActionReport = (appointmentId: number, isEmpty: boolean) => {
    const treatmentGroupId = treatmentPlan.appointmentsProgram.treatmentGroupId;
    const targetUser =
      treatmentGroupId && treatmentPlan.users && treatmentPlan.users.length > 0
        ? treatmentPlan.users[0]
        : treatmentPlan.user;

    navigate(`/users/report/`, {
      state: {
        TherapistDetails: {
          QuestionnaireCompaniesTypeId: 3,
          appointmentsId: isEmpty ? undefined : appointmentId,
          treatmentPlanId: treatmentPlan.appointmentsProgram.id,
          treatmentPlanServiceId: treatmentPlan.appointmentsProgram.companyServicesId,
          countOfAppointments:
            treatmentPlan.appointmentsProgram.countOfAppointments,
          treatmentGroupId: treatmentGroupId,
          treatmentGroupName: treatmentPlan.treatmentGroupName,
        },
        UserDetails: {
          FirstName: targetUser?.firstName,
          LastName: targetUser?.lastName,
          Phone: targetUser?.phone,
          UsersId: targetUser?.id,
          Guid: targetUser?.guid,
        },
      },
    });
  };

  useEffect(() => {
    if (programDatesList) {
      const sorted = [...programDatesList]
        .filter((item) => item.statusId && item.id > 0)
        .sort(
          (a, b) =>
            new Date(a.appointmentDate).getTime() -
            new Date(b.appointmentDate).getTime()
        );
      setProgramDates(sorted);
      // setProgramDatesList(sorted);

    }
  }, [programDatesList]);

  const fullAppointments = (): TAppointment[] => {
    const existing = programDates ?? [];
    const totalCount = treatmentPlan.appointmentsProgram.countOfAppointments;
    const missingCount = totalCount - existing.length;

    if (missingCount <= 0) return existing;

    const template = existing[0] ?? {
      id: -1,
      companyId: treatmentPlan.appointmentsProgram.companyId,
      usersId: treatmentPlan.user?.id ?? 0,
      users: treatmentPlan.user ?? {} as any,
      therapistsId: treatmentPlan.appointmentsProgram.therapistsId ?? 0,
      appointmentDate: new Date(NaN),
      startTime: undefined,
      endTime: null,
      statusId: null,
      isReport: null,
    };

    const emptyAppointments: TAppointment[] = Array.from(
      { length: missingCount },
      (_, i) => ({
        ...template,
        id: -1 * (i + 1),
        appointmentDate: new Date(NaN),
        startTime: undefined,
        endTime: undefined,
        statusId: 0,
        isReport: false,
      })
    );
    return [...existing, ...emptyAppointments];
  };

  const fullList = fullAppointments();

  return (
    <div className={styles.popup}>
      <article className={styles.popupArticle}>
        <h2 className={styles.popup__title}>{t("PLAN_DATES")}</h2>

        {fullList.length > 0 && (
          <ul className={styles.inquiries}>
            <li className={`${styles.inquiry} ${styles.inquiryHeader}`}>
              <p className={`${styles.inquiryCell} ${styles.inquiryNumber}`}>
                {mobile ? t("NUMBER") : t("MEETING_NUMBER")}
              </p>
              <p className={`${styles.inquiryCell} ${styles.inquiryDate}`}>
                {t("DATE")}
              </p>
              <p className={`${styles.inquiryCell} ${styles.inquiryWeekDay}`}>
                {t("WEEK_DAY")}
              </p>
              <p className={`${styles.inquiryCell} ${styles.inquiryName}`}>
                {mobile ? t("START") : t("START_TIME")}
              </p>
              <p className={`${styles.inquiryCell} ${styles.inquiryCycle}`}>
                {mobile ? t("END") : t("END_TIME")}
              </p>
              <p className={`${styles.inquiryCell} ${styles.inquiryContent}`}>
                {t("PROGRAM_DATES_POPUP_INQUIRY_STATUS")}
              </p>
              <p className={`${styles.inquiryCell} ${styles.inquiryContent}`}>
                {t("PROGRAM_DATES_POPUP_INQUIRY_REPORT")}
              </p>
            </li>

            {fullList.map((date, index) => {
              const isEmpty =
                !date.appointmentDate ||
                isNaN(new Date(date.appointmentDate).getTime());
              return (
                <li
                  key={index}
                  className={`${styles.inquiry} ${index % 2 === 0 ? styles.inquiry_colored : ""
                    }`}
                >
                  <p
                    className={`${styles.inquiryCell} ${styles.inquiryNumber}`}
                  >
                    {index + 1}
                  </p>
                  <p className={`${styles.inquiryCell} ${styles.inquiryDate}`}>
                    {isEmpty
                      ? "-"
                      : new Date(date.appointmentDate).toLocaleDateString(
                        "en-GB"
                      )}
                  </p>
                  <p
                    className={`${styles.inquiryCell} ${styles.inquiryWeekDay}`}
                  >
                    {isEmpty
                      ? "-"
                      : t(
                          weekDayTitleKeys[
                            new Date(date.appointmentDate).getDay()
                          ]
                        )}
                  </p>
                  <p className={`${styles.inquiryCell} ${styles.inquiryName}`}>
                    {date.startTime
                      ? date.startTime.split(":").slice(0, 2).join(":")
                      : "-"}
                  </p>
                  <p className={`${styles.inquiryCell} ${styles.inquiryCycle}`}>
                    {date.endTime
                      ? date.endTime.split(":").slice(0, 2).join(":")
                      : "-"}
                  </p>
                  <div className={`${styles.inquiryCell}`}>
                    {!isEmpty ? (
                      <button
                        className={`${styles.inquiryCell} button button_white ${styles.btn_take}`}
                        onClick={() => {
                          setCurrentDate(
                            new Date(date.appointmentDate).toLocaleDateString(
                              "en-GB"
                            )
                          );
                          setCancle(true);
                        }}
                      >
                        {isDateAfterToday(date.appointmentDate) ? t("CANCEL_ACTION") : t("UPDATE")}
                      </button>
                    ) : (
                      <p
                        className={`${styles.inquiryCell} ${styles.inquiryCycle}`}
                      >
                        -
                      </p>
                    )}
                  </div>
                  <div className={`${styles.inquiryCell}`}>
                    {!date.isReport ? (
                      <button
                        className={`button button_white ${styles.btn_take}`}
                        onClick={() => getActionReport(date.id, isEmpty)}
                      >
                        {t("ACTION_REPORT")}
                      </button>
                    ) : (
                      <img
                        src={reportsIcon}
                        alt={t("ACTION_REPORT")}
                        title={t("ACTION_REPORT")}
                      />
                    )}
                  </div>
                </li>
              );
            })}
          </ul>
        )}

        {fullList.length === 0 && isLoading && (
          <div className={styles.text}>
            <Loader />
          </div>
        )}
        {fullList.length === 0 && !isLoading && (
          <p className={styles.text}>{t("NO_DATES_FOUND")}</p>
        )}

        {currentDate && cancle && (
          <Modal onClose={() => setCancle(false)}>
            <CancleAppointmentPopup
              treatmentPlan={treatmentPlan}
              date={currentDate}
              setProgramDates={handleProgramDatesChanged}
              onSuccess={handleSuccessModal}
              onError={() => setOpenErrorModal(false)}
              onClose={() => setCancle(false)}
              onFullClose={() => {
                setCancle(false);
                onFullClose();
              }}
            />
          </Modal>
        )}

        {openSuccessModal && (
          <Modal onClose={() => setOpenSuccessModal(false)}>
            <AlternativeAppointmentPopup
              date={alternativeDate}
              onClose={() => setOpenSuccessModal(false)}
            />
          </Modal>
        )}

        {openErrorModal && (
          <Modal onClose={() => setOpenErrorModal(false)}>
            <GeneralErrorPopup onClose={() => setOpenErrorModal(false)} />
          </Modal>
        )}
      </article>
    </div>
  );
}

export default ProgramDatesPopup;
